export const matchmaking = {
  modal: {
    title: 'მატჩმეიკინგი',
  },
  search: {
    defaultMessage: 'ვეძებთ მოთამაშეს...',
    searchingForOpponent: 'ვეძებთ მოწინააღმდეგეს...',
    startingFreePlay: 'უფასო თამაში იწყება...',
    longWait:
      'როგორც ჩანს, ამ დროისთვის შენს დონესა და ფსონზე მოთამაშეები არ არის. სცადე მოგვიანებით.',
    restoring: 'მატჩმეიკინგის აღდგენა...',
    waitingForOpponent: 'ველოდებით მოწინააღმდეგის დადასტურებას...',
    loadingGame: 'თამაში იტვირთება...',
    cancel: 'გაუქმება',
    cancelSearch: 'ძებნის გაუქმება',
    cancelledTitle: 'ძებნა გაუქმდა',
    cancelledMessage: 'თქვენი ძებნა გაუქმდა',
  },
  stake: {
    findOpponent: 'მოწინააღმდეგის ძებნა',
    freePlay: 'უფასო თამაში',
    freePlayOr: 'ან ითამაშე ბოტთან',
    insufficientBalance: 'არასაკმარისი ბალანსი',
    entryFeeRange: 'შესვლის ფასი უნდა იყოს {{min}}-დან {{max}}-მდე',
    nextLeague:
      'მოიგე კიდევ {{count}} თამაში, რომ გახსნა უფრო მაღალი დონის ტურნირები',
    averageEntryFee: 'საშუალო შესვლის ფასი {{amount}}$',
    players: '{{count}} მოთამაშე',
    optionWin: 'მოგება {{amount}}',
    updatedEntryFee: 'განახლებული შესვლის ფასი',
    entryFeeDeclined: 'შესვლის ფასის განახლება უარყოფილია',
    entryFeeDeclinedMessage:
      'განახლებული შესვლის ფასი უარყოფილია. ძებნა გრძელდება...',
    difficulty: {
      easy: 'მარტივი',
      medium: 'საშუალო',
      hard: 'რთული',
    },
  },
  confirm: {
    gameFound: 'თამაში მოიძებნა!',
    opponent: 'მოწინააღმდეგე: {{name}}',
    acceptWithin: 'დაადასტურე {{time}}-ში',
  },
  result: {
    win: {
      congratulations: 'გილოცავ!',
      title: 'მოიგე!',
      payout: 'მოიგე {{amount}} $',
    },
    lose: {
      subtitle: 'ოჰ, არა...',
      title: 'წააგე',
    },
    draw: {
      subtitle: 'ამჯერად გამარჯვებული არ არის',
      title: 'ფრე!',
    },
    playAgain: 'თავიდან თამაში',
    findNewOpponent: 'ახალი მოწინააღმდეგის ძებნა',
    rematch: 'რევანში',
  },
  rematch: {
    waiting: 'ველოდებით, მოწინააღმდეგემ მიიღოს რევანში...',
    back: 'უკან',
  },
  activeGame: {
    message: 'თქვენ უკვე გაქვთ აქტიური თამაში.',
    title: 'აქტიური თამაში არსებობს',
    goToGame: 'აქტიურ თამაშში გადასვლა',
  },
  error: {
    title: 'მოხდა შეცდომა',
    generic: 'მოხდა შეცდომა',
    retry: 'თავიდან ცდა',
    connectionFailed: 'კავშირი ვერ დამყარდა',
    unknown: 'უცნობი შეცდომა',
    insufficientBalance: 'არასაკმარისი ბალანსი',
    cancelSearchFailed: 'ძებნის გაუქმება ვერ მოხერხდა',
    activeGameIdMissing:
      'აქტიური თამაშის გახსნა შეუძლებელია: აქტიური თამაშის ID არ არის',
    activeGameSlugMissing:
      'აქტიური თამაშის გახსნა შეუძლებელია: თამაშის slug არ არის',
    rematchUnavailable: 'რევანში მიუწვდომელია: lobby ID არ არის',
    rematchRequestFailed: 'რევანშის მოთხოვნა ვერ მოხერხდა',
    rematchDeclined: 'რევანშის მოთხოვნა უარყოფილია',
    rematchUnavailableExpired: 'რევანშის მოთხოვნა აღარ არის ხელმისაწვდომი',
    rematchCancelFailed: 'რევანშის გაუქმება ვერ მოხერხდა',
    rematchTimedOut: 'რევანშის მოთხოვნის დრო ამოიწურა',
  },
  common: {
    accept: 'დადასტურება',
    decline: 'უარყოფა',
    continue: 'გაგრძელება',
    back: 'უკან',
    you: 'შენ',
    opponent: 'მოწინააღმდეგე',
  },
  alt: {
    winnerTrophy: 'გამარჯვების თასი',
    sadEmoji: 'სევდიანი ემოჯი',
  },
  game: {
    giveUp: 'დანებება',
    mute: 'დამუნჯება',
    unmute: 'ხმის ჩართვა',
    howToPlay: 'როგორ ვითამაშო',
    rulesTitle: '{{gameName}} — წესები',
    gotIt: 'გასაგებია',
    turnStamp: {
      yourTurn: 'შენი სვლა',
      opponentTurn: 'მოწინააღმდეგის სვლა',
    },
    surrender: {
      title: 'დავუთმო თამაში?',
      description:
        'თუ ახლა დანებდები, თამაში დასრულდება\nდა მოწინააღმდეგე მოიგებს.\n\nამ მოქმედებას ვეღარ გააუქმებ.',
      keepPlaying: 'თამაშის გაგრძელება',
      confirm: 'დანებება',
    },
  },
};
